export const {
  buildBlockRecursive,
  renderTable,
  initializeFunctionality,
  transformTable,
} = WPTB.frontend;